var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorporate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 70"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.84999 -0.352539L-0.324219 4.94598V32.1703H23.4957V-0.352539H4.84999Z",
    fill: "#EAF4FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M-0.324219 10.3465V5.06836H4.83014",
    fill: "#C5E1F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.83014 -0.352539V4.92565H-0.324219",
    fill: "#7EB3FF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.85581 32.3536V28.9658H0.5625V32.3536",
    fill: "#0561FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.7972 32.3535V24.9004H8.50391V32.3535",
    fill: "#FD2227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M21.7347 32.3537V6.60645H16.4414V32.3537",
    fill: "#7EB3FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M29.6761 32.3534V16.7695H24.3828V32.3534",
    fill: "#0561FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M0.5625 26.9332L8.50246 18.8024L11.1491 21.5127L29.6757 2.54102",
    stroke: "#0450CF",
    strokeWidth: 1.36189
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M29.6761 7.96149V2.54102H24.3828",
    stroke: "#0450CF",
    strokeWidth: 1.36189
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporate);
export default __webpack_public_path__ + "static/media/corporate.a27956e62ebae3480b5425f183639fc1.svg";
export { ForwardRef as ReactComponent };